import { useMediaQuery,Grid2,Typography,Paper,InputBase,Divider,Box,Button,List,ListItem,ListItemText } from "@mui/material"
import Styles from "./BlogsStyles.module.css"
import searchButton from "../../../ui-utils/latestPics/faqButton.svg"
import blog from  "../../../ui-utils/latestPics/Blogs.svg"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState , useEffect,useRef,useCallback } from "react";
import BlogList from "./BlogsList";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { backendHosts,apiUrl } from "../../../ui-utils/apiConfig";

function slugify(title) {
    return title
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "");
}
export default function BlogMarket() {


        const [searchTerm, setSearchTerm] = useState("")
        const [suggestions, setSuggestions] = useState([])
        const navigate = useNavigate()
        const containerRef = useRef(null);

             const [allTags, setAllTags] = useState([]);
            const [selectedTag, setSelectedTag] = useState(null);
            const [blogs, setBlogs] = useState([]);
            const [loading, setLoading] = useState(false);
            const [page, setPage] = useState(1);
            const [hasMore, setHasMore] = useState(true);
            const [totalPages, setTotalPages] = useState(1);
            const observer = useRef();
            const loadingRef = useRef(false);
            const sentinelRef = useRef(null);

            const isSmallDevice = useMediaQuery("(max-width: 767px)");


            // const { language } = useLanguage();

            // console.log("language",language)
            // const translations = { en, hi, kn };
            // const t = translations[language] || translations.en;

            const fetchBlogs = useCallback(
                async (pageNum, tag = null) => {
                    if (loadingRef.current) return;
                    loadingRef.current = true;
                    setLoading(true);
                    const limit = isSmallDevice ? 3 : 6;
                    try {
                        let endPoint = `/api/blogs?page=${pageNum}&limit=${limit}`;
                        if (tag) {
                            endPoint += `&tag=${encodeURIComponent(tag)}`;
                        }

                        // const response = await httpRequest({
                        //     endPoint,
                        //     method: "get",
                        //     instance: "instanceOne",
                        // });

                        const response = await axios.get(`${backendHosts.ADMIN}${endPoint}`)

                        if (response?.data?.data && response?.data?.pagination) {
                            setBlogs((prev) => {
                                // If it's the first page or tag changed, replace the blogs
                                if (pageNum === 1 || tag !== selectedTag) {
                                    return response.data.data;
                                }
                                // Otherwise, append new blogs
                                return [...prev, ...response.data.data];
                            });
                            setTotalPages(response.data.pagination.totalPages);
                            setHasMore(pageNum < response.data.pagination.totalPages);
                        }
                    } catch (error) {
                        console.error("Error fetching blogs", error);
                    } finally {
                        loadingRef.current = false;
                        setLoading(false);
                    }
                },
                [selectedTag]
            );

            const [loadingTags, setLoadingTags] = useState(false);


            const fetchTags = useCallback(async () => {
                setLoadingTags(true);
                try {

                    const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getAllTags}`)
                    // const response = await httpRequest({
                    //     endPoint: `api/blogs/tags`,
                    //     method: "get",
                    //     instance: "instanceOne",
                    // });
                    setAllTags(response.data.tags || []);
                } catch (error) {
                    console.error("Error fetching tags", error);
                } finally {
                    setLoadingTags(false);
                }
            }, []);

            useEffect(() => {
                fetchTags();
            }, [fetchTags]);

            useEffect(() => {
                setBlogs([]);
                setPage(1);
                setHasMore(true);
            }, [selectedTag]);

            useEffect(() => {
                fetchBlogs(page, selectedTag);
            }, [page, selectedTag, fetchBlogs]);

            useEffect(() => {
                if (!hasMore || loading) return;

                const options = {
                    root: null,
                    rootMargin: "200px",
                    threshold: 0.1,
                };

                const handleIntersection = (entries) => {
                    const [entry] = entries;
                    if (entry.isIntersecting && !loadingRef.current) {
                        setPage((prev) => {
                            if (prev < totalPages) {
                                return prev + 1;
                            }
                            return prev;
                        });
                    }
                };

                observer.current = new IntersectionObserver(handleIntersection, options);

                if (sentinelRef.current) {
                    observer.current.observe(sentinelRef.current);
                }

                return () => {
                    if (observer.current) {
                        observer.current.disconnect();
                    }
                };
            }, [hasMore, loading, totalPages]);

        useEffect(() => {
            const delayDebounce = setTimeout(() => {
                if (searchTerm.trim().length > 2) {
                    fetchFaqSuggestions(searchTerm)
                } else {
                    setSuggestions([])
                }
            }, 300)

            return () => clearTimeout(delayDebounce)
        }, [searchTerm])

        const fetchFaqSuggestions = async (tag) => {
            try {

                const res = await axios.get(`${backendHosts.ADMIN}/api/blogs/search?blog=${tag}`)
                if (res.data?.status === 200) {
                    setSuggestions(res.data?.data || [])
                }
            } catch (error) {
                console.error("Search error:", error)
            }
        }

        const handleBlogClick = (blog) => {
            setSuggestions([]);
            setSearchTerm('');
            const slug = slugify(blog.blog_title);
            navigate(`/learn-research/blogs/${blog.id}-${slug}`);
            window.scrollTo(0, 0);


        }


    const isSmallScreen = useMediaQuery("(max-width:900px)");
    return (
        <div ref={containerRef} style={{ background: "#B3E1B7", minHeight: "100vh", position: "relative" }}>
        <Grid2
            item
            xs={12}
            textAlign="center"

        >
                {/* <Box

                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "100vw",
                        height: "100vh",
                        objectFit: "cover",
                        zIndex: 1,
                        display: "block",
                        background:"#DFFFE2",

                    }}
                >

                </Box> */}

                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "550px", // adjust based on how much DFFFE2 you want
                        background: "#DFFFE2",
                        zIndex: 1,
                    }}
                />
                <Grid2
                    item
                    xs={12}
                    textAlign="center"
                    sx={{
                        position: "relative",
                        zIndex: 2, // content is above both backgrounds
                        pt: 10,
                    }}
                >
            <Typography

                className={Styles.heading}
            >
                Blogs
            </Typography>
            <Typography

                sx={{
                    fontSize: { xs: "calc(14px + var(--font-delta))", sm: "calc(16px + var(--font-delta))", md: "calc(18px + var(--font-delta))", lg: "calc(20px + var(--font-delta))" },
                    color: "#1B1B1B",
                    maxWidth: "800px",
                    margin: "0 auto",
                    fontFamily: "Inter400",
                    lineHeight:"32px",
                    letterSpacing:"0px",
                    px: { xs: 2, sm: 4 },
                }}
            >
                The Tradeboss platform emphasizes transparency with a no-dealing-desk (NDD) model and provides resources for real-time market insights.
            </Typography>
              <Grid2 className={Styles.fieldCard} sx={{mb:5}}>
                <Box sx={{ position: "relative", width: "100%", maxWidth: "600px" }}>
                                        <Paper component="form" className={Styles.mobilefield}>
                                            {/* <Typography className={Styles.preMobile}>91</Typography> */}

                                            <InputBase
                                                className={Styles.inputbase}
                                                placeholder="Search"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                      <img src={searchButton} alt="faq2" className={Styles.button} />
                                        </Paper>
                                    {suggestions.length > 0 && (
                                        <List
                                            className={Styles.searchCard}

                                        >
                                            {suggestions.map((blog) => (
                                                <ListItem
                                                    key={blog.id}
                                                    button
                                                    onClick={() => handleBlogClick(blog)}
                                                >
                                                    <ListItemText primary={blog.blog_title} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    )}

                </Box>
                                    </Grid2>



                <BlogList blogs={blogs}/>

                    <div
                        ref={sentinelRef}
                        style={{
                            height: "1px",
                            width: "100%",
                        }}
                    />

       </Grid2>

        </Grid2>
    </div>
    )
}